import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TAGS_COLORS } from '@app-shared/constants/constants';
import { NgStyle } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TagContract } from '@app-types/api/tag';

@Component({
  selector: 'app-tag-component',
  templateUrl: './tag-component.component.html',
  styleUrls: ['./tag-component.component.scss'],
  imports: [NgStyle, MatIcon],
})
export class TagComponentComponent {
  @Input() tag: TagContract;
  @Input() withDelete = false;
  @Output() deleteTag = new EventEmitter<TagContract>();
  TAGS_COLORS = TAGS_COLORS;
  constructor() {}
}
